// source: fitness-service/v1/admin.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.fitness.service.v1.AdminStats', null, global);
goog.exportSymbol('proto.fitness.service.v1.AgencyDetails', null, global);
goog.exportSymbol('proto.fitness.service.v1.AgencyInfo', null, global);
goog.exportSymbol('proto.fitness.service.v1.AgencyOwner', null, global);
goog.exportSymbol('proto.fitness.service.v1.AgencyStats', null, global);
goog.exportSymbol('proto.fitness.service.v1.ApproveAgencyRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.ApproveAgencyResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetAdminStatsRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetAdminStatsResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetAgencyDetailsRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetAgencyDetailsResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetAllAgenciesRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetAllAgenciesResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetIndependentTrainersRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetIndependentTrainersResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetPendingAgenciesRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetPendingAgenciesResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.PendingAgency', null, global);
goog.exportSymbol('proto.fitness.service.v1.RejectAgencyRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.RejectAgencyResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.SetAgencyBrandingRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.SetAgencyBrandingResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.TrainerSummary', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.SetAgencyBrandingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.SetAgencyBrandingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.SetAgencyBrandingRequest.displayName = 'proto.fitness.service.v1.SetAgencyBrandingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.SetAgencyBrandingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.SetAgencyBrandingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.SetAgencyBrandingResponse.displayName = 'proto.fitness.service.v1.SetAgencyBrandingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetPendingAgenciesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetPendingAgenciesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetPendingAgenciesRequest.displayName = 'proto.fitness.service.v1.GetPendingAgenciesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetPendingAgenciesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetPendingAgenciesResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetPendingAgenciesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetPendingAgenciesResponse.displayName = 'proto.fitness.service.v1.GetPendingAgenciesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.PendingAgency = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.PendingAgency, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.PendingAgency.displayName = 'proto.fitness.service.v1.PendingAgency';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.AgencyOwner = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.AgencyOwner, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.AgencyOwner.displayName = 'proto.fitness.service.v1.AgencyOwner';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.ApproveAgencyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.ApproveAgencyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.ApproveAgencyRequest.displayName = 'proto.fitness.service.v1.ApproveAgencyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.ApproveAgencyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.ApproveAgencyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.ApproveAgencyResponse.displayName = 'proto.fitness.service.v1.ApproveAgencyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.RejectAgencyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.RejectAgencyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.RejectAgencyRequest.displayName = 'proto.fitness.service.v1.RejectAgencyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.RejectAgencyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.RejectAgencyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.RejectAgencyResponse.displayName = 'proto.fitness.service.v1.RejectAgencyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetAdminStatsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetAdminStatsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetAdminStatsRequest.displayName = 'proto.fitness.service.v1.GetAdminStatsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetAdminStatsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetAdminStatsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetAdminStatsResponse.displayName = 'proto.fitness.service.v1.GetAdminStatsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.AdminStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.AdminStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.AdminStats.displayName = 'proto.fitness.service.v1.AdminStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetAllAgenciesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetAllAgenciesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetAllAgenciesRequest.displayName = 'proto.fitness.service.v1.GetAllAgenciesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetAllAgenciesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetAllAgenciesResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetAllAgenciesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetAllAgenciesResponse.displayName = 'proto.fitness.service.v1.GetAllAgenciesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.AgencyInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.AgencyInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.AgencyInfo.displayName = 'proto.fitness.service.v1.AgencyInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetAgencyDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetAgencyDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetAgencyDetailsRequest.displayName = 'proto.fitness.service.v1.GetAgencyDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetAgencyDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetAgencyDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetAgencyDetailsResponse.displayName = 'proto.fitness.service.v1.GetAgencyDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.AgencyDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.AgencyDetails.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.AgencyDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.AgencyDetails.displayName = 'proto.fitness.service.v1.AgencyDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.TrainerSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.TrainerSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.TrainerSummary.displayName = 'proto.fitness.service.v1.TrainerSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetIndependentTrainersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetIndependentTrainersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetIndependentTrainersRequest.displayName = 'proto.fitness.service.v1.GetIndependentTrainersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetIndependentTrainersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetIndependentTrainersResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetIndependentTrainersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetIndependentTrainersResponse.displayName = 'proto.fitness.service.v1.GetIndependentTrainersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.AgencyStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.AgencyStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.AgencyStats.displayName = 'proto.fitness.service.v1.AgencyStats';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.SetAgencyBrandingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.SetAgencyBrandingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.SetAgencyBrandingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.SetAgencyBrandingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
agencyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.SetAgencyBrandingRequest}
 */
proto.fitness.service.v1.SetAgencyBrandingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.SetAgencyBrandingRequest;
  return proto.fitness.service.v1.SetAgencyBrandingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.SetAgencyBrandingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.SetAgencyBrandingRequest}
 */
proto.fitness.service.v1.SetAgencyBrandingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAgencyId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.SetAgencyBrandingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.SetAgencyBrandingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.SetAgencyBrandingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.SetAgencyBrandingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAgencyId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional uint32 agency_id = 1;
 * @return {number}
 */
proto.fitness.service.v1.SetAgencyBrandingRequest.prototype.getAgencyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.SetAgencyBrandingRequest} returns this
 */
proto.fitness.service.v1.SetAgencyBrandingRequest.prototype.setAgencyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool enabled = 2;
 * @return {boolean}
 */
proto.fitness.service.v1.SetAgencyBrandingRequest.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.SetAgencyBrandingRequest} returns this
 */
proto.fitness.service.v1.SetAgencyBrandingRequest.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.SetAgencyBrandingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.SetAgencyBrandingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.SetAgencyBrandingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.SetAgencyBrandingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
brandingEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.SetAgencyBrandingResponse}
 */
proto.fitness.service.v1.SetAgencyBrandingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.SetAgencyBrandingResponse;
  return proto.fitness.service.v1.SetAgencyBrandingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.SetAgencyBrandingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.SetAgencyBrandingResponse}
 */
proto.fitness.service.v1.SetAgencyBrandingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBrandingEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.SetAgencyBrandingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.SetAgencyBrandingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.SetAgencyBrandingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.SetAgencyBrandingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getBrandingEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.fitness.service.v1.SetAgencyBrandingResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.SetAgencyBrandingResponse} returns this
 */
proto.fitness.service.v1.SetAgencyBrandingResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool branding_enabled = 2;
 * @return {boolean}
 */
proto.fitness.service.v1.SetAgencyBrandingResponse.prototype.getBrandingEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.SetAgencyBrandingResponse} returns this
 */
proto.fitness.service.v1.SetAgencyBrandingResponse.prototype.setBrandingEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetPendingAgenciesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetPendingAgenciesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetPendingAgenciesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetPendingAgenciesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetPendingAgenciesRequest}
 */
proto.fitness.service.v1.GetPendingAgenciesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetPendingAgenciesRequest;
  return proto.fitness.service.v1.GetPendingAgenciesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetPendingAgenciesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetPendingAgenciesRequest}
 */
proto.fitness.service.v1.GetPendingAgenciesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetPendingAgenciesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetPendingAgenciesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetPendingAgenciesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetPendingAgenciesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetPendingAgenciesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetPendingAgenciesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetPendingAgenciesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetPendingAgenciesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetPendingAgenciesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
agenciesList: jspb.Message.toObjectList(msg.getAgenciesList(),
    proto.fitness.service.v1.PendingAgency.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetPendingAgenciesResponse}
 */
proto.fitness.service.v1.GetPendingAgenciesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetPendingAgenciesResponse;
  return proto.fitness.service.v1.GetPendingAgenciesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetPendingAgenciesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetPendingAgenciesResponse}
 */
proto.fitness.service.v1.GetPendingAgenciesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.PendingAgency;
      reader.readMessage(value,proto.fitness.service.v1.PendingAgency.deserializeBinaryFromReader);
      msg.addAgencies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetPendingAgenciesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetPendingAgenciesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetPendingAgenciesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetPendingAgenciesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAgenciesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fitness.service.v1.PendingAgency.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PendingAgency agencies = 1;
 * @return {!Array<!proto.fitness.service.v1.PendingAgency>}
 */
proto.fitness.service.v1.GetPendingAgenciesResponse.prototype.getAgenciesList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.PendingAgency>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.PendingAgency, 1));
};


/**
 * @param {!Array<!proto.fitness.service.v1.PendingAgency>} value
 * @return {!proto.fitness.service.v1.GetPendingAgenciesResponse} returns this
*/
proto.fitness.service.v1.GetPendingAgenciesResponse.prototype.setAgenciesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fitness.service.v1.PendingAgency=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.PendingAgency}
 */
proto.fitness.service.v1.GetPendingAgenciesResponse.prototype.addAgencies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fitness.service.v1.PendingAgency, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetPendingAgenciesResponse} returns this
 */
proto.fitness.service.v1.GetPendingAgenciesResponse.prototype.clearAgenciesList = function() {
  return this.setAgenciesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.PendingAgency.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.PendingAgency.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.PendingAgency} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.PendingAgency.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
address: jspb.Message.getFieldWithDefault(msg, 4, ""),
contactPhone: jspb.Message.getFieldWithDefault(msg, 5, ""),
contactEmail: jspb.Message.getFieldWithDefault(msg, 6, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
owner: (f = msg.getOwner()) && proto.fitness.service.v1.AgencyOwner.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.PendingAgency}
 */
proto.fitness.service.v1.PendingAgency.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.PendingAgency;
  return proto.fitness.service.v1.PendingAgency.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.PendingAgency} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.PendingAgency}
 */
proto.fitness.service.v1.PendingAgency.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAddress(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContactPhone(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContactEmail(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = new proto.fitness.service.v1.AgencyOwner;
      reader.readMessage(value,proto.fitness.service.v1.AgencyOwner.deserializeBinaryFromReader);
      msg.setOwner(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.PendingAgency.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.PendingAgency.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.PendingAgency} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.PendingAgency.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContactPhone();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getContactEmail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOwner();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.fitness.service.v1.AgencyOwner.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.fitness.service.v1.PendingAgency.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.PendingAgency} returns this
 */
proto.fitness.service.v1.PendingAgency.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.fitness.service.v1.PendingAgency.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.PendingAgency} returns this
 */
proto.fitness.service.v1.PendingAgency.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.fitness.service.v1.PendingAgency.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.PendingAgency} returns this
 */
proto.fitness.service.v1.PendingAgency.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string address = 4;
 * @return {string}
 */
proto.fitness.service.v1.PendingAgency.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.PendingAgency} returns this
 */
proto.fitness.service.v1.PendingAgency.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string contact_phone = 5;
 * @return {string}
 */
proto.fitness.service.v1.PendingAgency.prototype.getContactPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.PendingAgency} returns this
 */
proto.fitness.service.v1.PendingAgency.prototype.setContactPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string contact_email = 6;
 * @return {string}
 */
proto.fitness.service.v1.PendingAgency.prototype.getContactEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.PendingAgency} returns this
 */
proto.fitness.service.v1.PendingAgency.prototype.setContactEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.PendingAgency.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.PendingAgency} returns this
*/
proto.fitness.service.v1.PendingAgency.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.PendingAgency} returns this
 */
proto.fitness.service.v1.PendingAgency.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.PendingAgency.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional AgencyOwner owner = 8;
 * @return {?proto.fitness.service.v1.AgencyOwner}
 */
proto.fitness.service.v1.PendingAgency.prototype.getOwner = function() {
  return /** @type{?proto.fitness.service.v1.AgencyOwner} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.AgencyOwner, 8));
};


/**
 * @param {?proto.fitness.service.v1.AgencyOwner|undefined} value
 * @return {!proto.fitness.service.v1.PendingAgency} returns this
*/
proto.fitness.service.v1.PendingAgency.prototype.setOwner = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.PendingAgency} returns this
 */
proto.fitness.service.v1.PendingAgency.prototype.clearOwner = function() {
  return this.setOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.PendingAgency.prototype.hasOwner = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.AgencyOwner.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.AgencyOwner.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.AgencyOwner} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AgencyOwner.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
firstName: jspb.Message.getFieldWithDefault(msg, 2, ""),
lastName: jspb.Message.getFieldWithDefault(msg, 3, ""),
email: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.AgencyOwner}
 */
proto.fitness.service.v1.AgencyOwner.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.AgencyOwner;
  return proto.fitness.service.v1.AgencyOwner.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.AgencyOwner} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.AgencyOwner}
 */
proto.fitness.service.v1.AgencyOwner.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFirstName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.AgencyOwner.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.AgencyOwner.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.AgencyOwner} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AgencyOwner.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.fitness.service.v1.AgencyOwner.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AgencyOwner} returns this
 */
proto.fitness.service.v1.AgencyOwner.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string first_name = 2;
 * @return {string}
 */
proto.fitness.service.v1.AgencyOwner.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyOwner} returns this
 */
proto.fitness.service.v1.AgencyOwner.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string last_name = 3;
 * @return {string}
 */
proto.fitness.service.v1.AgencyOwner.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyOwner} returns this
 */
proto.fitness.service.v1.AgencyOwner.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string email = 4;
 * @return {string}
 */
proto.fitness.service.v1.AgencyOwner.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyOwner} returns this
 */
proto.fitness.service.v1.AgencyOwner.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.ApproveAgencyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.ApproveAgencyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.ApproveAgencyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ApproveAgencyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
agencyId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.ApproveAgencyRequest}
 */
proto.fitness.service.v1.ApproveAgencyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.ApproveAgencyRequest;
  return proto.fitness.service.v1.ApproveAgencyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.ApproveAgencyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.ApproveAgencyRequest}
 */
proto.fitness.service.v1.ApproveAgencyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAgencyId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.ApproveAgencyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.ApproveAgencyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.ApproveAgencyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ApproveAgencyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAgencyId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 agency_id = 1;
 * @return {number}
 */
proto.fitness.service.v1.ApproveAgencyRequest.prototype.getAgencyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ApproveAgencyRequest} returns this
 */
proto.fitness.service.v1.ApproveAgencyRequest.prototype.setAgencyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.ApproveAgencyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.ApproveAgencyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.ApproveAgencyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ApproveAgencyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, ""),
success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.ApproveAgencyResponse}
 */
proto.fitness.service.v1.ApproveAgencyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.ApproveAgencyResponse;
  return proto.fitness.service.v1.ApproveAgencyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.ApproveAgencyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.ApproveAgencyResponse}
 */
proto.fitness.service.v1.ApproveAgencyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.ApproveAgencyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.ApproveAgencyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.ApproveAgencyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ApproveAgencyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.fitness.service.v1.ApproveAgencyResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.ApproveAgencyResponse} returns this
 */
proto.fitness.service.v1.ApproveAgencyResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.fitness.service.v1.ApproveAgencyResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.ApproveAgencyResponse} returns this
 */
proto.fitness.service.v1.ApproveAgencyResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.RejectAgencyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.RejectAgencyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.RejectAgencyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.RejectAgencyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
agencyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
reason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.RejectAgencyRequest}
 */
proto.fitness.service.v1.RejectAgencyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.RejectAgencyRequest;
  return proto.fitness.service.v1.RejectAgencyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.RejectAgencyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.RejectAgencyRequest}
 */
proto.fitness.service.v1.RejectAgencyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAgencyId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.RejectAgencyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.RejectAgencyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.RejectAgencyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.RejectAgencyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAgencyId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 agency_id = 1;
 * @return {number}
 */
proto.fitness.service.v1.RejectAgencyRequest.prototype.getAgencyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.RejectAgencyRequest} returns this
 */
proto.fitness.service.v1.RejectAgencyRequest.prototype.setAgencyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.fitness.service.v1.RejectAgencyRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.RejectAgencyRequest} returns this
 */
proto.fitness.service.v1.RejectAgencyRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.RejectAgencyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.RejectAgencyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.RejectAgencyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.RejectAgencyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, ""),
success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.RejectAgencyResponse}
 */
proto.fitness.service.v1.RejectAgencyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.RejectAgencyResponse;
  return proto.fitness.service.v1.RejectAgencyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.RejectAgencyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.RejectAgencyResponse}
 */
proto.fitness.service.v1.RejectAgencyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.RejectAgencyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.RejectAgencyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.RejectAgencyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.RejectAgencyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.fitness.service.v1.RejectAgencyResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.RejectAgencyResponse} returns this
 */
proto.fitness.service.v1.RejectAgencyResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.fitness.service.v1.RejectAgencyResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.RejectAgencyResponse} returns this
 */
proto.fitness.service.v1.RejectAgencyResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetAdminStatsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetAdminStatsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetAdminStatsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAdminStatsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetAdminStatsRequest}
 */
proto.fitness.service.v1.GetAdminStatsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetAdminStatsRequest;
  return proto.fitness.service.v1.GetAdminStatsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetAdminStatsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetAdminStatsRequest}
 */
proto.fitness.service.v1.GetAdminStatsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetAdminStatsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetAdminStatsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetAdminStatsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAdminStatsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetAdminStatsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetAdminStatsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetAdminStatsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAdminStatsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
stats: (f = msg.getStats()) && proto.fitness.service.v1.AdminStats.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetAdminStatsResponse}
 */
proto.fitness.service.v1.GetAdminStatsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetAdminStatsResponse;
  return proto.fitness.service.v1.GetAdminStatsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetAdminStatsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetAdminStatsResponse}
 */
proto.fitness.service.v1.GetAdminStatsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.AdminStats;
      reader.readMessage(value,proto.fitness.service.v1.AdminStats.deserializeBinaryFromReader);
      msg.setStats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetAdminStatsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetAdminStatsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetAdminStatsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAdminStatsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStats();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.AdminStats.serializeBinaryToWriter
    );
  }
};


/**
 * optional AdminStats stats = 1;
 * @return {?proto.fitness.service.v1.AdminStats}
 */
proto.fitness.service.v1.GetAdminStatsResponse.prototype.getStats = function() {
  return /** @type{?proto.fitness.service.v1.AdminStats} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.AdminStats, 1));
};


/**
 * @param {?proto.fitness.service.v1.AdminStats|undefined} value
 * @return {!proto.fitness.service.v1.GetAdminStatsResponse} returns this
*/
proto.fitness.service.v1.GetAdminStatsResponse.prototype.setStats = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetAdminStatsResponse} returns this
 */
proto.fitness.service.v1.GetAdminStatsResponse.prototype.clearStats = function() {
  return this.setStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetAdminStatsResponse.prototype.hasStats = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.AdminStats.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.AdminStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.AdminStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AdminStats.toObject = function(includeInstance, msg) {
  var f, obj = {
totalAgencies: jspb.Message.getFieldWithDefault(msg, 1, 0),
activeAgencies: jspb.Message.getFieldWithDefault(msg, 2, 0),
pendingAgencies: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalTrainers: jspb.Message.getFieldWithDefault(msg, 4, 0),
activeTrainers: jspb.Message.getFieldWithDefault(msg, 5, 0),
totalClients: jspb.Message.getFieldWithDefault(msg, 6, 0),
activeClients: jspb.Message.getFieldWithDefault(msg, 7, 0),
totalWorkouts: jspb.Message.getFieldWithDefault(msg, 8, 0),
totalExercises: jspb.Message.getFieldWithDefault(msg, 9, 0),
independentTrainers: jspb.Message.getFieldWithDefault(msg, 10, 0),
activeIndependentTrainers: jspb.Message.getFieldWithDefault(msg, 11, 0),
newIndependentTrainers30d: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.AdminStats}
 */
proto.fitness.service.v1.AdminStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.AdminStats;
  return proto.fitness.service.v1.AdminStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.AdminStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.AdminStats}
 */
proto.fitness.service.v1.AdminStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalAgencies(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setActiveAgencies(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPendingAgencies(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalTrainers(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setActiveTrainers(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalClients(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setActiveClients(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalWorkouts(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalExercises(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setIndependentTrainers(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setActiveIndependentTrainers(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNewIndependentTrainers30d(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.AdminStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.AdminStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.AdminStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AdminStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalAgencies();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getActiveAgencies();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getPendingAgencies();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotalTrainers();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getActiveTrainers();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getTotalClients();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getActiveClients();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getTotalWorkouts();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getTotalExercises();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getIndependentTrainers();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getActiveIndependentTrainers();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getNewIndependentTrainers30d();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
};


/**
 * optional uint32 total_agencies = 1;
 * @return {number}
 */
proto.fitness.service.v1.AdminStats.prototype.getTotalAgencies = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AdminStats} returns this
 */
proto.fitness.service.v1.AdminStats.prototype.setTotalAgencies = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 active_agencies = 2;
 * @return {number}
 */
proto.fitness.service.v1.AdminStats.prototype.getActiveAgencies = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AdminStats} returns this
 */
proto.fitness.service.v1.AdminStats.prototype.setActiveAgencies = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 pending_agencies = 3;
 * @return {number}
 */
proto.fitness.service.v1.AdminStats.prototype.getPendingAgencies = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AdminStats} returns this
 */
proto.fitness.service.v1.AdminStats.prototype.setPendingAgencies = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 total_trainers = 4;
 * @return {number}
 */
proto.fitness.service.v1.AdminStats.prototype.getTotalTrainers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AdminStats} returns this
 */
proto.fitness.service.v1.AdminStats.prototype.setTotalTrainers = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 active_trainers = 5;
 * @return {number}
 */
proto.fitness.service.v1.AdminStats.prototype.getActiveTrainers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AdminStats} returns this
 */
proto.fitness.service.v1.AdminStats.prototype.setActiveTrainers = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 total_clients = 6;
 * @return {number}
 */
proto.fitness.service.v1.AdminStats.prototype.getTotalClients = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AdminStats} returns this
 */
proto.fitness.service.v1.AdminStats.prototype.setTotalClients = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 active_clients = 7;
 * @return {number}
 */
proto.fitness.service.v1.AdminStats.prototype.getActiveClients = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AdminStats} returns this
 */
proto.fitness.service.v1.AdminStats.prototype.setActiveClients = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 total_workouts = 8;
 * @return {number}
 */
proto.fitness.service.v1.AdminStats.prototype.getTotalWorkouts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AdminStats} returns this
 */
proto.fitness.service.v1.AdminStats.prototype.setTotalWorkouts = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 total_exercises = 9;
 * @return {number}
 */
proto.fitness.service.v1.AdminStats.prototype.getTotalExercises = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AdminStats} returns this
 */
proto.fitness.service.v1.AdminStats.prototype.setTotalExercises = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint32 independent_trainers = 10;
 * @return {number}
 */
proto.fitness.service.v1.AdminStats.prototype.getIndependentTrainers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AdminStats} returns this
 */
proto.fitness.service.v1.AdminStats.prototype.setIndependentTrainers = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional uint32 active_independent_trainers = 11;
 * @return {number}
 */
proto.fitness.service.v1.AdminStats.prototype.getActiveIndependentTrainers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AdminStats} returns this
 */
proto.fitness.service.v1.AdminStats.prototype.setActiveIndependentTrainers = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional uint32 new_independent_trainers_30d = 12;
 * @return {number}
 */
proto.fitness.service.v1.AdminStats.prototype.getNewIndependentTrainers30d = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AdminStats} returns this
 */
proto.fitness.service.v1.AdminStats.prototype.setNewIndependentTrainers30d = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetAllAgenciesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetAllAgenciesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetAllAgenciesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAllAgenciesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
activeOnly: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
search: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetAllAgenciesRequest}
 */
proto.fitness.service.v1.GetAllAgenciesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetAllAgenciesRequest;
  return proto.fitness.service.v1.GetAllAgenciesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetAllAgenciesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetAllAgenciesRequest}
 */
proto.fitness.service.v1.GetAllAgenciesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActiveOnly(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSearch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetAllAgenciesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetAllAgenciesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetAllAgenciesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAllAgenciesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getActiveOnly();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getSearch();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional uint32 page = 1;
 * @return {number}
 */
proto.fitness.service.v1.GetAllAgenciesRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAllAgenciesRequest} returns this
 */
proto.fitness.service.v1.GetAllAgenciesRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetAllAgenciesRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAllAgenciesRequest} returns this
 */
proto.fitness.service.v1.GetAllAgenciesRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool active_only = 3;
 * @return {boolean}
 */
proto.fitness.service.v1.GetAllAgenciesRequest.prototype.getActiveOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.GetAllAgenciesRequest} returns this
 */
proto.fitness.service.v1.GetAllAgenciesRequest.prototype.setActiveOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string search = 4;
 * @return {string}
 */
proto.fitness.service.v1.GetAllAgenciesRequest.prototype.getSearch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetAllAgenciesRequest} returns this
 */
proto.fitness.service.v1.GetAllAgenciesRequest.prototype.setSearch = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetAllAgenciesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetAllAgenciesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetAllAgenciesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetAllAgenciesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAllAgenciesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
agenciesList: jspb.Message.toObjectList(msg.getAgenciesList(),
    proto.fitness.service.v1.AgencyInfo.toObject, includeInstance),
totalCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetAllAgenciesResponse}
 */
proto.fitness.service.v1.GetAllAgenciesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetAllAgenciesResponse;
  return proto.fitness.service.v1.GetAllAgenciesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetAllAgenciesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetAllAgenciesResponse}
 */
proto.fitness.service.v1.GetAllAgenciesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.AgencyInfo;
      reader.readMessage(value,proto.fitness.service.v1.AgencyInfo.deserializeBinaryFromReader);
      msg.addAgencies(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetAllAgenciesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetAllAgenciesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetAllAgenciesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAllAgenciesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAgenciesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fitness.service.v1.AgencyInfo.serializeBinaryToWriter
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * repeated AgencyInfo agencies = 1;
 * @return {!Array<!proto.fitness.service.v1.AgencyInfo>}
 */
proto.fitness.service.v1.GetAllAgenciesResponse.prototype.getAgenciesList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.AgencyInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.AgencyInfo, 1));
};


/**
 * @param {!Array<!proto.fitness.service.v1.AgencyInfo>} value
 * @return {!proto.fitness.service.v1.GetAllAgenciesResponse} returns this
*/
proto.fitness.service.v1.GetAllAgenciesResponse.prototype.setAgenciesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fitness.service.v1.AgencyInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.AgencyInfo}
 */
proto.fitness.service.v1.GetAllAgenciesResponse.prototype.addAgencies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fitness.service.v1.AgencyInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetAllAgenciesResponse} returns this
 */
proto.fitness.service.v1.GetAllAgenciesResponse.prototype.clearAgenciesList = function() {
  return this.setAgenciesList([]);
};


/**
 * optional uint32 total_count = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetAllAgenciesResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAllAgenciesResponse} returns this
 */
proto.fitness.service.v1.GetAllAgenciesResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 page = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetAllAgenciesResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAllAgenciesResponse} returns this
 */
proto.fitness.service.v1.GetAllAgenciesResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 limit = 4;
 * @return {number}
 */
proto.fitness.service.v1.GetAllAgenciesResponse.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAllAgenciesResponse} returns this
 */
proto.fitness.service.v1.GetAllAgenciesResponse.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.AgencyInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.AgencyInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.AgencyInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AgencyInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
address: jspb.Message.getFieldWithDefault(msg, 4, ""),
contactPhone: jspb.Message.getFieldWithDefault(msg, 5, ""),
contactEmail: jspb.Message.getFieldWithDefault(msg, 6, ""),
isActive: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
owner: (f = msg.getOwner()) && proto.fitness.service.v1.AgencyOwner.toObject(includeInstance, f),
trainerCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
clientCount: jspb.Message.getFieldWithDefault(msg, 12, 0),
lastActivity: (f = msg.getLastActivity()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
isIndependent: jspb.Message.getBooleanFieldWithDefault(msg, 14, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.AgencyInfo}
 */
proto.fitness.service.v1.AgencyInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.AgencyInfo;
  return proto.fitness.service.v1.AgencyInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.AgencyInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.AgencyInfo}
 */
proto.fitness.service.v1.AgencyInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAddress(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContactPhone(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContactEmail(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 10:
      var value = new proto.fitness.service.v1.AgencyOwner;
      reader.readMessage(value,proto.fitness.service.v1.AgencyOwner.deserializeBinaryFromReader);
      msg.setOwner(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTrainerCount(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setClientCount(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastActivity(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsIndependent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.AgencyInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.AgencyInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.AgencyInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AgencyInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContactPhone();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getContactEmail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOwner();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.fitness.service.v1.AgencyOwner.serializeBinaryToWriter
    );
  }
  f = message.getTrainerCount();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getClientCount();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getLastActivity();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsIndependent();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.fitness.service.v1.AgencyInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
 */
proto.fitness.service.v1.AgencyInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.fitness.service.v1.AgencyInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
 */
proto.fitness.service.v1.AgencyInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.fitness.service.v1.AgencyInfo.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
 */
proto.fitness.service.v1.AgencyInfo.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string address = 4;
 * @return {string}
 */
proto.fitness.service.v1.AgencyInfo.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
 */
proto.fitness.service.v1.AgencyInfo.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string contact_phone = 5;
 * @return {string}
 */
proto.fitness.service.v1.AgencyInfo.prototype.getContactPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
 */
proto.fitness.service.v1.AgencyInfo.prototype.setContactPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string contact_email = 6;
 * @return {string}
 */
proto.fitness.service.v1.AgencyInfo.prototype.getContactEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
 */
proto.fitness.service.v1.AgencyInfo.prototype.setContactEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool is_active = 7;
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyInfo.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
 */
proto.fitness.service.v1.AgencyInfo.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.AgencyInfo.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
*/
proto.fitness.service.v1.AgencyInfo.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
 */
proto.fitness.service.v1.AgencyInfo.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyInfo.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.AgencyInfo.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
*/
proto.fitness.service.v1.AgencyInfo.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
 */
proto.fitness.service.v1.AgencyInfo.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyInfo.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional AgencyOwner owner = 10;
 * @return {?proto.fitness.service.v1.AgencyOwner}
 */
proto.fitness.service.v1.AgencyInfo.prototype.getOwner = function() {
  return /** @type{?proto.fitness.service.v1.AgencyOwner} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.AgencyOwner, 10));
};


/**
 * @param {?proto.fitness.service.v1.AgencyOwner|undefined} value
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
*/
proto.fitness.service.v1.AgencyInfo.prototype.setOwner = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
 */
proto.fitness.service.v1.AgencyInfo.prototype.clearOwner = function() {
  return this.setOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyInfo.prototype.hasOwner = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional uint32 trainer_count = 11;
 * @return {number}
 */
proto.fitness.service.v1.AgencyInfo.prototype.getTrainerCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
 */
proto.fitness.service.v1.AgencyInfo.prototype.setTrainerCount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional uint32 client_count = 12;
 * @return {number}
 */
proto.fitness.service.v1.AgencyInfo.prototype.getClientCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
 */
proto.fitness.service.v1.AgencyInfo.prototype.setClientCount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional google.protobuf.Timestamp last_activity = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.AgencyInfo.prototype.getLastActivity = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
*/
proto.fitness.service.v1.AgencyInfo.prototype.setLastActivity = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
 */
proto.fitness.service.v1.AgencyInfo.prototype.clearLastActivity = function() {
  return this.setLastActivity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyInfo.prototype.hasLastActivity = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional bool is_independent = 14;
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyInfo.prototype.getIsIndependent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.AgencyInfo} returns this
 */
proto.fitness.service.v1.AgencyInfo.prototype.setIsIndependent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetAgencyDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetAgencyDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetAgencyDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencyDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
agencyId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetAgencyDetailsRequest}
 */
proto.fitness.service.v1.GetAgencyDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetAgencyDetailsRequest;
  return proto.fitness.service.v1.GetAgencyDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetAgencyDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetAgencyDetailsRequest}
 */
proto.fitness.service.v1.GetAgencyDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAgencyId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetAgencyDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetAgencyDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetAgencyDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencyDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAgencyId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 agency_id = 1;
 * @return {number}
 */
proto.fitness.service.v1.GetAgencyDetailsRequest.prototype.getAgencyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAgencyDetailsRequest} returns this
 */
proto.fitness.service.v1.GetAgencyDetailsRequest.prototype.setAgencyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetAgencyDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetAgencyDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetAgencyDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencyDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
agency: (f = msg.getAgency()) && proto.fitness.service.v1.AgencyDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetAgencyDetailsResponse}
 */
proto.fitness.service.v1.GetAgencyDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetAgencyDetailsResponse;
  return proto.fitness.service.v1.GetAgencyDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetAgencyDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetAgencyDetailsResponse}
 */
proto.fitness.service.v1.GetAgencyDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.AgencyDetails;
      reader.readMessage(value,proto.fitness.service.v1.AgencyDetails.deserializeBinaryFromReader);
      msg.setAgency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetAgencyDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetAgencyDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetAgencyDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencyDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAgency();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.AgencyDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional AgencyDetails agency = 1;
 * @return {?proto.fitness.service.v1.AgencyDetails}
 */
proto.fitness.service.v1.GetAgencyDetailsResponse.prototype.getAgency = function() {
  return /** @type{?proto.fitness.service.v1.AgencyDetails} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.AgencyDetails, 1));
};


/**
 * @param {?proto.fitness.service.v1.AgencyDetails|undefined} value
 * @return {!proto.fitness.service.v1.GetAgencyDetailsResponse} returns this
*/
proto.fitness.service.v1.GetAgencyDetailsResponse.prototype.setAgency = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetAgencyDetailsResponse} returns this
 */
proto.fitness.service.v1.GetAgencyDetailsResponse.prototype.clearAgency = function() {
  return this.setAgency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetAgencyDetailsResponse.prototype.hasAgency = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.AgencyDetails.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.AgencyDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.AgencyDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.AgencyDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AgencyDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
address: jspb.Message.getFieldWithDefault(msg, 4, ""),
contactPhone: jspb.Message.getFieldWithDefault(msg, 5, ""),
contactEmail: jspb.Message.getFieldWithDefault(msg, 6, ""),
isActive: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
owner: (f = msg.getOwner()) && proto.fitness.service.v1.AgencyOwner.toObject(includeInstance, f),
trainersList: jspb.Message.toObjectList(msg.getTrainersList(),
    proto.fitness.service.v1.TrainerSummary.toObject, includeInstance),
agencyStats: (f = msg.getAgencyStats()) && proto.fitness.service.v1.AgencyStats.toObject(includeInstance, f),
brandingEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
brandName: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.AgencyDetails}
 */
proto.fitness.service.v1.AgencyDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.AgencyDetails;
  return proto.fitness.service.v1.AgencyDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.AgencyDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.AgencyDetails}
 */
proto.fitness.service.v1.AgencyDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAddress(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContactPhone(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContactEmail(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 10:
      var value = new proto.fitness.service.v1.AgencyOwner;
      reader.readMessage(value,proto.fitness.service.v1.AgencyOwner.deserializeBinaryFromReader);
      msg.setOwner(value);
      break;
    case 11:
      var value = new proto.fitness.service.v1.TrainerSummary;
      reader.readMessage(value,proto.fitness.service.v1.TrainerSummary.deserializeBinaryFromReader);
      msg.addTrainers(value);
      break;
    case 12:
      var value = new proto.fitness.service.v1.AgencyStats;
      reader.readMessage(value,proto.fitness.service.v1.AgencyStats.deserializeBinaryFromReader);
      msg.setAgencyStats(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBrandingEnabled(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBrandName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.AgencyDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.AgencyDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.AgencyDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AgencyDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContactPhone();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getContactEmail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOwner();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.fitness.service.v1.AgencyOwner.serializeBinaryToWriter
    );
  }
  f = message.getTrainersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.fitness.service.v1.TrainerSummary.serializeBinaryToWriter
    );
  }
  f = message.getAgencyStats();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.fitness.service.v1.AgencyStats.serializeBinaryToWriter
    );
  }
  f = message.getBrandingEnabled();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getBrandName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.fitness.service.v1.AgencyDetails.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
 */
proto.fitness.service.v1.AgencyDetails.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.fitness.service.v1.AgencyDetails.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
 */
proto.fitness.service.v1.AgencyDetails.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.fitness.service.v1.AgencyDetails.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
 */
proto.fitness.service.v1.AgencyDetails.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string address = 4;
 * @return {string}
 */
proto.fitness.service.v1.AgencyDetails.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
 */
proto.fitness.service.v1.AgencyDetails.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string contact_phone = 5;
 * @return {string}
 */
proto.fitness.service.v1.AgencyDetails.prototype.getContactPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
 */
proto.fitness.service.v1.AgencyDetails.prototype.setContactPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string contact_email = 6;
 * @return {string}
 */
proto.fitness.service.v1.AgencyDetails.prototype.getContactEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
 */
proto.fitness.service.v1.AgencyDetails.prototype.setContactEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool is_active = 7;
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyDetails.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
 */
proto.fitness.service.v1.AgencyDetails.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.AgencyDetails.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
*/
proto.fitness.service.v1.AgencyDetails.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
 */
proto.fitness.service.v1.AgencyDetails.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyDetails.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.AgencyDetails.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
*/
proto.fitness.service.v1.AgencyDetails.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
 */
proto.fitness.service.v1.AgencyDetails.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyDetails.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional AgencyOwner owner = 10;
 * @return {?proto.fitness.service.v1.AgencyOwner}
 */
proto.fitness.service.v1.AgencyDetails.prototype.getOwner = function() {
  return /** @type{?proto.fitness.service.v1.AgencyOwner} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.AgencyOwner, 10));
};


/**
 * @param {?proto.fitness.service.v1.AgencyOwner|undefined} value
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
*/
proto.fitness.service.v1.AgencyDetails.prototype.setOwner = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
 */
proto.fitness.service.v1.AgencyDetails.prototype.clearOwner = function() {
  return this.setOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyDetails.prototype.hasOwner = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * repeated TrainerSummary trainers = 11;
 * @return {!Array<!proto.fitness.service.v1.TrainerSummary>}
 */
proto.fitness.service.v1.AgencyDetails.prototype.getTrainersList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.TrainerSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.TrainerSummary, 11));
};


/**
 * @param {!Array<!proto.fitness.service.v1.TrainerSummary>} value
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
*/
proto.fitness.service.v1.AgencyDetails.prototype.setTrainersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.fitness.service.v1.TrainerSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.TrainerSummary}
 */
proto.fitness.service.v1.AgencyDetails.prototype.addTrainers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.fitness.service.v1.TrainerSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
 */
proto.fitness.service.v1.AgencyDetails.prototype.clearTrainersList = function() {
  return this.setTrainersList([]);
};


/**
 * optional AgencyStats agency_stats = 12;
 * @return {?proto.fitness.service.v1.AgencyStats}
 */
proto.fitness.service.v1.AgencyDetails.prototype.getAgencyStats = function() {
  return /** @type{?proto.fitness.service.v1.AgencyStats} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.AgencyStats, 12));
};


/**
 * @param {?proto.fitness.service.v1.AgencyStats|undefined} value
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
*/
proto.fitness.service.v1.AgencyDetails.prototype.setAgencyStats = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
 */
proto.fitness.service.v1.AgencyDetails.prototype.clearAgencyStats = function() {
  return this.setAgencyStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyDetails.prototype.hasAgencyStats = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool branding_enabled = 13;
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyDetails.prototype.getBrandingEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
 */
proto.fitness.service.v1.AgencyDetails.prototype.setBrandingEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional string brand_name = 14;
 * @return {string}
 */
proto.fitness.service.v1.AgencyDetails.prototype.getBrandName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyDetails} returns this
 */
proto.fitness.service.v1.AgencyDetails.prototype.setBrandName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.TrainerSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.TrainerSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.TrainerSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.TrainerSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
userId: jspb.Message.getFieldWithDefault(msg, 2, 0),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
email: jspb.Message.getFieldWithDefault(msg, 4, ""),
specialization: jspb.Message.getFieldWithDefault(msg, 5, ""),
experienceYears: jspb.Message.getFieldWithDefault(msg, 6, 0),
isActive: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
clientCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
joinDate: (f = msg.getJoinDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
lastLogin: (f = msg.getLastLogin()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
trainerCode: jspb.Message.getFieldWithDefault(msg, 11, ""),
instagramHandle: jspb.Message.getFieldWithDefault(msg, 12, ""),
certification: jspb.Message.getFieldWithDefault(msg, 13, ""),
phone: jspb.Message.getFieldWithDefault(msg, 14, ""),
isIndependent: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
agencyId: jspb.Message.getFieldWithDefault(msg, 16, 0),
brandingEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 17, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.TrainerSummary}
 */
proto.fitness.service.v1.TrainerSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.TrainerSummary;
  return proto.fitness.service.v1.TrainerSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.TrainerSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.TrainerSummary}
 */
proto.fitness.service.v1.TrainerSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSpecialization(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExperienceYears(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setClientCount(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setJoinDate(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastLogin(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTrainerCode(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setInstagramHandle(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCertification(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPhone(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsIndependent(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAgencyId(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBrandingEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.TrainerSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.TrainerSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.TrainerSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.TrainerSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSpecialization();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getExperienceYears();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getClientCount();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getJoinDate();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastLogin();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTrainerCode();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getInstagramHandle();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCertification();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getIsIndependent();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getAgencyId();
  if (f !== 0) {
    writer.writeUint32(
      16,
      f
    );
  }
  f = message.getBrandingEnabled();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 user_id = 2;
 * @return {number}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string email = 4;
 * @return {string}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string specialization = 5;
 * @return {string}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getSpecialization = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setSpecialization = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 experience_years = 6;
 * @return {number}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getExperienceYears = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setExperienceYears = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool is_active = 7;
 * @return {boolean}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional uint32 client_count = 8;
 * @return {number}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getClientCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setClientCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp join_date = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getJoinDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
*/
proto.fitness.service.v1.TrainerSummary.prototype.setJoinDate = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.clearJoinDate = function() {
  return this.setJoinDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.TrainerSummary.prototype.hasJoinDate = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp last_login = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getLastLogin = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
*/
proto.fitness.service.v1.TrainerSummary.prototype.setLastLogin = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.clearLastLogin = function() {
  return this.setLastLogin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.TrainerSummary.prototype.hasLastLogin = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string trainer_code = 11;
 * @return {string}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getTrainerCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setTrainerCode = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string instagram_handle = 12;
 * @return {string}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getInstagramHandle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setInstagramHandle = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string certification = 13;
 * @return {string}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getCertification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setCertification = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string phone = 14;
 * @return {string}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional bool is_independent = 15;
 * @return {boolean}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getIsIndependent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setIsIndependent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional uint32 agency_id = 16;
 * @return {number}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getAgencyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setAgencyId = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional bool branding_enabled = 17;
 * @return {boolean}
 */
proto.fitness.service.v1.TrainerSummary.prototype.getBrandingEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.TrainerSummary} returns this
 */
proto.fitness.service.v1.TrainerSummary.prototype.setBrandingEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetIndependentTrainersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetIndependentTrainersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetIndependentTrainersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetIndependentTrainersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
activeOnly: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
search: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetIndependentTrainersRequest}
 */
proto.fitness.service.v1.GetIndependentTrainersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetIndependentTrainersRequest;
  return proto.fitness.service.v1.GetIndependentTrainersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetIndependentTrainersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetIndependentTrainersRequest}
 */
proto.fitness.service.v1.GetIndependentTrainersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActiveOnly(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSearch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetIndependentTrainersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetIndependentTrainersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetIndependentTrainersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetIndependentTrainersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getActiveOnly();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getSearch();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional uint32 page = 1;
 * @return {number}
 */
proto.fitness.service.v1.GetIndependentTrainersRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetIndependentTrainersRequest} returns this
 */
proto.fitness.service.v1.GetIndependentTrainersRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetIndependentTrainersRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetIndependentTrainersRequest} returns this
 */
proto.fitness.service.v1.GetIndependentTrainersRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool active_only = 3;
 * @return {boolean}
 */
proto.fitness.service.v1.GetIndependentTrainersRequest.prototype.getActiveOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.GetIndependentTrainersRequest} returns this
 */
proto.fitness.service.v1.GetIndependentTrainersRequest.prototype.setActiveOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string search = 4;
 * @return {string}
 */
proto.fitness.service.v1.GetIndependentTrainersRequest.prototype.getSearch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetIndependentTrainersRequest} returns this
 */
proto.fitness.service.v1.GetIndependentTrainersRequest.prototype.setSearch = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetIndependentTrainersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetIndependentTrainersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
trainersList: jspb.Message.toObjectList(msg.getTrainersList(),
    proto.fitness.service.v1.TrainerSummary.toObject, includeInstance),
totalCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetIndependentTrainersResponse}
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetIndependentTrainersResponse;
  return proto.fitness.service.v1.GetIndependentTrainersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetIndependentTrainersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetIndependentTrainersResponse}
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.TrainerSummary;
      reader.readMessage(value,proto.fitness.service.v1.TrainerSummary.deserializeBinaryFromReader);
      msg.addTrainers(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetIndependentTrainersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetIndependentTrainersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrainersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fitness.service.v1.TrainerSummary.serializeBinaryToWriter
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * repeated TrainerSummary trainers = 1;
 * @return {!Array<!proto.fitness.service.v1.TrainerSummary>}
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.prototype.getTrainersList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.TrainerSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.TrainerSummary, 1));
};


/**
 * @param {!Array<!proto.fitness.service.v1.TrainerSummary>} value
 * @return {!proto.fitness.service.v1.GetIndependentTrainersResponse} returns this
*/
proto.fitness.service.v1.GetIndependentTrainersResponse.prototype.setTrainersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fitness.service.v1.TrainerSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.TrainerSummary}
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.prototype.addTrainers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fitness.service.v1.TrainerSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetIndependentTrainersResponse} returns this
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.prototype.clearTrainersList = function() {
  return this.setTrainersList([]);
};


/**
 * optional uint32 total_count = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetIndependentTrainersResponse} returns this
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 page = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetIndependentTrainersResponse} returns this
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 limit = 4;
 * @return {number}
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetIndependentTrainersResponse} returns this
 */
proto.fitness.service.v1.GetIndependentTrainersResponse.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.AgencyStats.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.AgencyStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.AgencyStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AgencyStats.toObject = function(includeInstance, msg) {
  var f, obj = {
totalTrainers: jspb.Message.getFieldWithDefault(msg, 1, 0),
activeTrainers: jspb.Message.getFieldWithDefault(msg, 2, 0),
totalClients: jspb.Message.getFieldWithDefault(msg, 3, 0),
activeClients: jspb.Message.getFieldWithDefault(msg, 4, 0),
totalWorkouts: jspb.Message.getFieldWithDefault(msg, 5, 0),
monthlyWorkouts: jspb.Message.getFieldWithDefault(msg, 6, 0),
totalExercises: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.AgencyStats}
 */
proto.fitness.service.v1.AgencyStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.AgencyStats;
  return proto.fitness.service.v1.AgencyStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.AgencyStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.AgencyStats}
 */
proto.fitness.service.v1.AgencyStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalTrainers(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setActiveTrainers(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalClients(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setActiveClients(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalWorkouts(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMonthlyWorkouts(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalExercises(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.AgencyStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.AgencyStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.AgencyStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AgencyStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalTrainers();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getActiveTrainers();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getTotalClients();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getActiveClients();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getTotalWorkouts();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getMonthlyWorkouts();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getTotalExercises();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
};


/**
 * optional uint32 total_trainers = 1;
 * @return {number}
 */
proto.fitness.service.v1.AgencyStats.prototype.getTotalTrainers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AgencyStats} returns this
 */
proto.fitness.service.v1.AgencyStats.prototype.setTotalTrainers = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 active_trainers = 2;
 * @return {number}
 */
proto.fitness.service.v1.AgencyStats.prototype.getActiveTrainers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AgencyStats} returns this
 */
proto.fitness.service.v1.AgencyStats.prototype.setActiveTrainers = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 total_clients = 3;
 * @return {number}
 */
proto.fitness.service.v1.AgencyStats.prototype.getTotalClients = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AgencyStats} returns this
 */
proto.fitness.service.v1.AgencyStats.prototype.setTotalClients = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 active_clients = 4;
 * @return {number}
 */
proto.fitness.service.v1.AgencyStats.prototype.getActiveClients = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AgencyStats} returns this
 */
proto.fitness.service.v1.AgencyStats.prototype.setActiveClients = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 total_workouts = 5;
 * @return {number}
 */
proto.fitness.service.v1.AgencyStats.prototype.getTotalWorkouts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AgencyStats} returns this
 */
proto.fitness.service.v1.AgencyStats.prototype.setTotalWorkouts = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 monthly_workouts = 6;
 * @return {number}
 */
proto.fitness.service.v1.AgencyStats.prototype.getMonthlyWorkouts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AgencyStats} returns this
 */
proto.fitness.service.v1.AgencyStats.prototype.setMonthlyWorkouts = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 total_exercises = 7;
 * @return {number}
 */
proto.fitness.service.v1.AgencyStats.prototype.getTotalExercises = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AgencyStats} returns this
 */
proto.fitness.service.v1.AgencyStats.prototype.setTotalExercises = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


goog.object.extend(exports, proto.fitness.service.v1);
